import { render, staticRenderFns } from "./MarketingOverview.vue?vue&type=template&id=213b5738"
import script from "./MarketingOverview.vue?vue&type=script&lang=js"
export * from "./MarketingOverview.vue?vue&type=script&lang=js"
import style0 from "./MarketingOverview.vue?vue&type=style&index=0&id=213b5738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports